<main>
  <novus-header></novus-header>
  <section>
    <router-outlet></router-outlet>
  </section>
</main>
